export default {"src":"/uk/_next/static/media/biometricsIcon.1d2e435b.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};